import { useState } from 'react';
import { Stack, IconButton, Typography, Popover } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import CloseIcon from '@mui/icons-material/Close';
import { EventItemDisplay } from './EventItemDisplay';
import { RegistrationTab } from './RegistrationTab';
import { useTBContext } from '../Contexts/useTBStates';

interface RegistrationPopoutProps {
    compHeights: any;
    appDims: any;
    gridHeight: number;
    gridWidth: number;
    //handleRegistrationUpdate: () => void;
    //registrationRef: any;
}

export const RegistrationPopout = ({ compHeights, appDims, gridHeight, gridWidth }: RegistrationPopoutProps) => {
    
    const { factor, appTheme } = useTBContext();
    
    const [open, setOpen] = useState(false);

    return (
        <Stack direction={'row'} spacing={2} sx={{ display: 'flex', height: 60*factor, justifyContent: 'flex-start', padding: '0px 20px', alignItems: 'center' }}>
            <IconButton color='primary'
                sx = {{
                    width: '100%',
                    borderRadius: 2,
                    padding: 0.5,
                    justifyContent: 'flex-start',
                    border: '1px solid transparent',
                    '&:hover': {border: `1px solid ${appTheme.palette.primary.extraLight}`},
                    '&:active': {backgroundColor: 'transparent'},
                    '&:focus': {backgroundColor: 'transparent'},
                }}
            onClick={() => {
                setOpen(true);
            }}>
                <Typography variant='subtitle2' color='primary.main' sx={{ fontWeight: 500, fontSize: 14, display: 'flex', alignItems: 'center', textAlign: 'left', justifyItems: 'center' }}>
                    <LaunchIcon sx={{ fontSize: 16 }} />Registrations
                </Typography>
            </IconButton>
            <Popover
                open={open}
                anchorEl={document.getElementById('tournament-builder-footer')}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                sx={{
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}  
                PaperProps={{
                    sx: {
                        backgroundColor: 'white',
                        margin: 'auto 10%', // Center horizontally
                        width: '80vw', // Ensure it has a defined width,
                        height: '90vh',
                        padding: 2,
                    }
                }}
            >
                <Stack direction='column' spacing={2} sx={{
                    width: '100%', 
                    height: '100%', 
                    /* padding: 2, */
                    zIndex: 1000,
                    
                }}>
                    <Stack direction={'row'} spacing={2} 
                        sx={{ display: 'flex', height: 60*factor, justifyContent: 'flex-end', 
                            padding: '0px 20px', alignItems: 'center',
                            borderBottom: `1px dotted ${appTheme.palette.primary.light}`,
                        }}
                    >
                        <Typography flex={2} sx={{ fontSize: 16*factor*1.25 }}>Registrations</Typography>
                        <IconButton color='error'
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <RegistrationTab
                        compHeights={compHeights}
                        appDims={appDims}
                        gridHeight={gridHeight}
                        gridWidth={gridWidth}
                        //handleRegistrationUpdate={handleRegistrationUpdate}
                        //registrationRef={registrationRef}
                    />
                </Stack>
            </Popover>
        </Stack>
    )
}
